var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMortgage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "current",
    strokeWidth: 0,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "wrapper",
    clipPath: "url(#clip0_13349_21302)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M15.2778 11.5417V5.26388L10.9722 2.25L6.66667 5.26388V7.47225H5.27779V4.56944L10.9722 0.5L16.6667 4.56944V11.5417H15.2778ZM11.3889 6.19446H12.2222V5.36112H11.3889V6.19446ZM9.72223 6.19446H10.5556V5.36112H9.72223V6.19446ZM11.3889 7.86112H12.2222V7.02779H11.3889V7.86112ZM9.72223 7.86112H10.5556V7.02779H9.72223V7.86112ZM4.65277 15.0834L10.8472 16.8611L15.9445 15.2639C15.9213 15.0371 15.816 14.8461 15.6285 14.691C15.441 14.5359 15.2222 14.4583 14.9722 14.4583H10.6667C10.3935 14.4583 10.1481 14.4421 9.93056 14.4097C9.71297 14.3773 9.49537 14.3241 9.27777 14.25L7.2986 13.632L7.71527 12.2431L9.58333 12.875C9.76389 12.9352 9.96065 12.9815 10.1736 13.0139C10.3866 13.0463 10.6481 13.0648 10.9583 13.0695H11.7361C11.7361 12.8241 11.6562 12.6065 11.4965 12.4167C11.3368 12.2269 11.1435 12.088 10.9167 12L6.2639 10.25H4.65277V15.0834ZM0 17.7222V8.86112H6.25C6.33179 8.86112 6.41358 8.86923 6.49538 8.88544C6.57715 8.90163 6.65508 8.92362 6.72917 8.9514L11.3889 10.6945C11.8935 10.8796 12.316 11.1852 12.6562 11.6111C12.9965 12.0371 13.1667 12.5232 13.1667 13.0695H14.9722C15.6744 13.0695 16.2712 13.3171 16.7627 13.8125C17.2542 14.3079 17.5 14.9167 17.5 15.6389V16.2778L10.9306 18.3056L4.65277 16.5278V17.7222H0ZM1.38888 16.3334H3.25V10.25H1.38888V16.3334Z",
    fill: ""
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13349_21302"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMortgage);
export default __webpack_public_path__ + "static/media/Mortgage.622d44238d66848a8ad0446df28036da.svg";
export { ForwardRef as ReactComponent };